// Campos obrigatórios de uma Ficha de Pessoa e o cálculo de pendências.

export const CAMPOS_OBRIGATORIOS_PJ = [
  { campo: "cnpj", label: "CNPJ" },
  { campo: "razaoSocial", label: "Razão Social" },
  { campo: "email", label: "E-mail" },
];
export const CAMPOS_OBRIGATORIOS_PF = [
  { campo: "pfNome", label: "Nome Completo" },
  { campo: "pfDtNascimento", label: "Data de Nascimento" },
  { campo: "cpf", label: "CPF" },
  { campo: "pfEstadoCivil", label: "Estado Civil" },
];

export const CAMPOS_OBRIGATORIOS_PJ_REPRESENTANTE = [
  { campo: "pfNome", label: "Nome do Representante Legal" },
  { campo: "cpf", label: "CPF do Representante Legal" },
];

export const CAMPOS_OBRIGATORIOS_ESTRANGEIRO = [
  { campo: "documentoEstrangeiroTipo", label: "Tipo do Documento Estrangeiro" },
  { campo: "documentoEstrangeiroNumero", label: "Número do Documento Estrangeiro" },
  { campo: "documentoEstrangeiroPais", label: "País Emissor" },
];

export function camposObrigatoriosDaFicha(ficha) {
  if (!ficha) return [];

  const campos = [];

  if (ficha.tipoPessoa === "PJ") {
    campos.push(...CAMPOS_OBRIGATORIOS_PJ);
    campos.push(...CAMPOS_OBRIGATORIOS_PJ_REPRESENTANTE);
  } else {
    campos.push(...CAMPOS_OBRIGATORIOS_PF);
  }

  // Estrangeiro: CPF/CNPJ opcionais. Sem o CPF/CNPJ principal (CNPJ na PJ, CPF na PF),
  // o documento estrangeiro passa a ser obrigatório.
  if (ficha.estrangeiro) {
    const documentoPrincipal = String((ficha.tipoPessoa === "PJ" ? ficha.cnpj : ficha.cpf) || "").trim();
    const semDocumento = campos.filter(({ campo }) => campo !== "cnpj" && campo !== "cpf");
    return documentoPrincipal ? semDocumento : [...semDocumento, ...CAMPOS_OBRIGATORIOS_ESTRANGEIRO];
  }

  return campos;
}

export function pendenciasDaFicha(ficha) {
  if (!ficha) return [];

  return camposObrigatoriosDaFicha(ficha)
    .filter(({ campo }) => {
      const valor = ficha[campo];

      if (typeof valor === "string") {
        return !valor.trim();
      }

      return valor === null || valor === undefined || valor === "";
    })
    .map(({ campo, label }) => ({
      campo,
      label,
    }));
}
